import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BankAccount, NewEventPayment, EventPaymentCapture, EventPaymentRefund } from './event-payment.types';

@Injectable()
export class EventPaymentService {
	private eventPaymentsUrl = (eventId: number) => `api/events/${eventId}/payments`;
	private usUrl = (url: string) => `${url}/US`;

	constructor(private _http: HttpClient) { }

	getBankAccountDetails(eventId: number): Promise<BankAccount> {
		return this._http.get<BankAccount>(`api/events/${eventId}/customers/me/bankDetails`).toPromise();
	}

	getCustomerBankAccountDetails(eventId: number, customerId: number): Promise<BankAccount> {
		return this._http.get<BankAccount>(`api/events/${eventId}/customers/${customerId}/bankDetails`).toPromise();
	}

	makePayment(eventId: number, newPayment: NewEventPayment): Promise<number> {
		return this._http.post<number>(this.eventPaymentsUrl(eventId), newPayment).toPromise();
	}

	capturePayment(eventId: number, paymentId: number, capture: EventPaymentCapture): Promise<number> {
		return this._http.put<number>(`${this.eventPaymentsUrl(eventId)}/${paymentId}`, capture).toPromise();
	}

	refundPayment(eventId: number, paymentId: number, refund: EventPaymentRefund): Promise<void> {
		return this._http.post<void>(`${this.eventPaymentsUrl(eventId)}/${paymentId}`, refund).toPromise();
	}

	makePaymentUs(eventId: number, newPayment: NewEventPayment): Promise<number> {
		return this._http.post<number>(this.usUrl(this.eventPaymentsUrl(eventId)), newPayment).toPromise();
	}

	capturePaymentUs(eventId: number, paymentId: number, capture: EventPaymentCapture): Promise<number> {
		return this._http.put<number>(this.usUrl(`${this.eventPaymentsUrl(eventId)}/${paymentId}`), capture).toPromise();
	}

	refundPaymentUs(eventId: number, paymentId: number, refund: EventPaymentRefund): Promise<void> {
		return this._http.post<void>(this.usUrl(`${this.eventPaymentsUrl(eventId)}/${paymentId}`), refund).toPromise();
	}
}
